export var DatamanagerRole;
(function (DatamanagerRole) {
    DatamanagerRole["PSAdmin"] = "3pq-ps-admin";
    DatamanagerRole["DMAdmin"] = "3pq-dm-admin";
    DatamanagerRole["DMUser"] = "3pq-dm-user";
})(DatamanagerRole || (DatamanagerRole = {}));
//# sourceMappingURL=DatamanagerRole.js.map